export default __webpack_public_path__ + "static/media/responsivex1.e4c50d73.png";